/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CompanyNameResponseAllOf,
    CompanyNameResponseAllOfFromJSON,
    CompanyNameResponseAllOfFromJSONTyped,
    CompanyNameResponseAllOfToJSON,
} from './CompanyNameResponseAllOf';
import {
    CompanyNameResponseAllOfData,
    CompanyNameResponseAllOfDataFromJSON,
    CompanyNameResponseAllOfDataFromJSONTyped,
    CompanyNameResponseAllOfDataToJSON,
} from './CompanyNameResponseAllOfData';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';

/**
 * 検索した企業一覧を取得したときのレスポンス
 * @export
 * @interface CompanyNameResponse
 */
export interface CompanyNameResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof CompanyNameResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof CompanyNameResponse
     */
    message: string;
    /**
     * 
     * @type {CompanyNameResponseAllOfData}
     * @memberof CompanyNameResponse
     */
    data: CompanyNameResponseAllOfData;
}

export function CompanyNameResponseFromJSON(json: any): CompanyNameResponse {
    return CompanyNameResponseFromJSONTyped(json, false);
}

export function CompanyNameResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyNameResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': CompanyNameResponseAllOfDataFromJSON(json['data']),
    };
}

export function CompanyNameResponseToJSON(value?: CompanyNameResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': CompanyNameResponseAllOfDataToJSON(value.data),
    };
}

